import { render, staticRenderFns } from "./top-title.vue?vue&type=template&id=0a9521c2&scoped=true"
import script from "./top-title.vue?vue&type=script&lang=js"
export * from "./top-title.vue?vue&type=script&lang=js"
import style0 from "./top-title.vue?vue&type=style&index=0&id=0a9521c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9521c2",
  null
  
)

export default component.exports